
(() => {
  const initFlorenciaAnimations = () => {
    const elements = document.querySelectorAll(
      '.fw-animate:not([data-fw-ready])'
    );

    if (window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches) {
      elements.forEach((el) => {
        el.classList.add('is-visible');
        el.dataset.fwReady = 'true';
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      elements.forEach((el) => {
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -35px 0px'
      }
    );

    elements.forEach((el) => {
      el.dataset.fwReady = 'true';
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initFlorenciaAnimations
    );
  } else {
    initFlorenciaAnimations();
  }

  document.addEventListener(
    'shopify:section:load',
    initFlorenciaAnimations
  );
})();
